import * as Types from '../generated/types';

import { gql } from '@apollo/client';
import { BrandNodeFragmentDoc } from './brandNode.generated';
export type CarModelNodeFragment = { __typename?: 'CarModelNode', id: string, name: string, localName?: string | null, brand: { __typename?: 'BrandNode', id: string, name: string } };

export const CarModelNodeFragmentDoc = gql`
    fragment CarModelNode on CarModelNode {
  id
  name
  localName
  brand {
    ...BrandNode
  }
}
    ${BrandNodeFragmentDoc}`;